<template>
    <div>
        <div class="page-header pr-0">
            <h2><a href="/dashboard"><i class="fas fa-tachometer-alt"></i></a></h2>
            <ol class="breadcrumbs">
                <li class="active"><span>Establecimientos</span></li>
            </ol>
            <div class="right-wrapper pull-right">

                <button type="button" class="btn btn-custom btn-sm  mt-2 mr-2"
                    @click.prevent="clickCreate()"><i class="fa fa-plus-circle"></i> Nuevo</button>

                <!--<button type="button" class="btn btn-custom btn-sm  mt-2 mr-2" @click.prevent="clickImport()"><i class="fa fa-upload"></i> Importar</button>-->
            </div>
        </div>
        <div class="card">
            <div class="card-header bg-info">
                <h3 class="my-0">Listado de establecimientos</h3>
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Descripción</th>
                                <th class="text-right">Código</th>
                                <th class="text-right">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in records" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ row.description }}</td>
                                <td class="text-right">{{ row.code }}</td>
                                <td class="text-right">
                                    <button type="button" class="btn waves-effect waves-light btn-xs btn-info"
                                        @click.prevent="clickCreate(row.id)">Editar</button>
                                    <button type="button" class="btn waves-effect waves-light btn-xs btn-danger"
                                        v-if="typeUser != 'integrator'"
                                        @click.prevent="clickDelete(row.id)">Eliminar</button>
                                    <button type="button" class="btn waves-effect waves-light btn-xs btn-warning"
                                        @click.prevent="clickSeries(row.id)">Series</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <div class="row">
                    <div class="col">
                        <button type="button" class="btn btn-custom btn-sm  mt-2 mr-2" v-if="typeUser != 'integrator'" @click.prevent="clickCreate()"><i class="fa fa-plus-circle"></i> Nuevo</button>
                    </div>
                </div> -->
            </div>
            <establishments-form :showDialog.sync="showDialog" :recordId="recordId"></establishments-form>
            <establishment-series :showDialog.sync="showDialogSeries"
                :establishmentId="recordId"></establishment-series>
        </div>
    </div>
</template>

<script>

import EstablishmentsForm from './form1.vue'
import { deletable } from '../../../mixins/deletable'
import EstablishmentSeries from './partials/series.vue'

export default {
    props: ['typeUser', 'configuration'],
    mixins: [deletable],
    components: { EstablishmentsForm, EstablishmentSeries },
    data() {
        return {
            showDialog: false,
            resource: 'establishments',
            recordId: null,
            records: [],
            showDialogSeries: false,
            establishment: null,
        }
    },
    created() {
        this.$eventHub.$on('reloadData', () => {
            this.getData()
        })
        this.getData()
        console.log(this.configuration)
    },
    computed:
    {
        canCreateEstablishment() {
            if (this.typeUser !== 'admin') return false

            var plan = (this.configuration && this.configuration.plan) ? this.configuration.plan : null
            if (!plan) return false

            var limit = (plan.establishments_limit !== null && plan.establishments_limit !== undefined) ? Number(plan.establishments_limit) : 0

            if (limit === 0) return true

            var currentEstablishment = this.records ? this.records.length : 0

            return currentEstablishment < limit
        }
    },
    methods: {
        getData() {
            this.$http.get(`/${this.resource}/records`)
                .then(response => {
                    this.records = response.data.data
                })
        },
        clickCreate(recordId = null) {
            this.recordId = recordId
            this.showDialog = true
        },
        clickSeries(recordId = null) {
            this.recordId = recordId
            this.showDialogSeries = true
        },
        clickDelete(id) {
            this.destroy(`/${this.resource}/${id}`).then(() =>
                this.$eventHub.$emit('reloadData')
            )
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/establishments/index.vue